import { render, staticRenderFns } from "./CreateDubliсateInvoice.vue?vue&type=template&id=72a61d84&scoped=true&"
import script from "./CreateDubliсateInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateDubliсateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CreateDubliсateInvoice.vue?vue&type=style&index=0&id=72a61d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a61d84",
  null
  
)

export default component.exports